"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldWrapper = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const styled_components_1 = __importDefault(require("styled-components"));
exports.FieldWrapper = styled_components_1.default.div `
  display: grid;
  grid-template-columns: 150px 1fr;
  grid-column-gap: 15px;
  grid-row-gap: 10px;
  align-items: center;
`;
//# sourceMappingURL=FieldWrapper.js.map